import Marquee from "react-fast-marquee";
import { SKILLS } from "../data/site";

export default function TechMarquee() {
  return (
    <section
      id="skills"
      data-testid="tech-marquee-section"
      className="relative py-16 md:py-24 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10">
        <div className="flex items-center gap-3">
          <span className="w-10 h-px bg-[#f5e6d3]" />
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#f5e6d3]">
            Stack — 002
          </span>
        </div>
      </div>

      <Marquee gradient gradientColor="#050505" speed={45} pauseOnHover>
        {SKILLS.map((s, i) => (
          <span
            key={s + i}
            data-testid={`tech-item-${s.toLowerCase().replace(/\s+/g, "-")}`}
            className="font-display uppercase text-5xl md:text-7xl lg:text-8xl tracking-tight px-8 md:px-14 text-white/90"
          >
            {s}
            <span className="text-[#f5e6d3] mx-4">*</span>
          </span>
        ))}
      </Marquee>

      <Marquee
        gradient
        gradientColor="#050505"
        speed={35}
        direction="right"
        className="mt-6 opacity-40"
      >
        {SKILLS.map((s, i) => (
          <span
            key={"r" + s + i}
            className="font-editorial italic text-4xl md:text-6xl px-8 md:px-12 text-zinc-400"
          >
            {s} —
          </span>
        ))}
      </Marquee>
    </section>
  );
}
